'use client'

import { AuthProvider } from '@/contexts/AuthContext'
import { Toaster } from 'sonner'
import { CompanyProvider } from '@/contexts/CompanyContext'
import { NotificationProvider } from '@/contexts/NotificationContext'

export function Providers({ children }: { children: React.ReactNode }) {
  return (
    <AuthProvider>
      <NotificationProvider>
        <CompanyProvider>
          {children}
          <Toaster richColors />
        </CompanyProvider>
      </NotificationProvider>
    </AuthProvider>
  )
} 